<nav role="navigation" class="navbar">
  <div class="container">
    <a href="//www.policybazaar.com/" >
      <img [src]="pbLogo" class="logo-box" />
    </a>
  </div>
</nav>
@if (feedbackDetails?.IsFeedbackPageHide) {
  <div class="container feedbackWrapper">
    <div class="feedbackMsg" >
      The page you are looking for does not exist. Sorry :(
    </div>
  </div>
}
@if (ProductId == 117 && !feedbackDetails?.IsFeedbackPageHide) {
  <div>
    <div class="container feedbackWrapper">
      @if (!feedbackDetails?.LinkExpired && !feedbackDetails?.IsFeedBackSubmitted && !IsFeedBackSubmittedOneTime && ClaimCustDetails.AgentRating==1) {
        <div class="feedbackMsg">
          <!-- We appreciate you rating our agent as <span>{{Rating}}</span>. We would request you to complete this short feedback survey. -->
        </div>
      }
      @if (!feedbackDetails?.LinkExpired && !feedbackDetails?.IsFeedBackSubmitted && !IsFeedBackSubmittedOneTime && ClaimCustDetails.AgentRating==2) {
        <div class="feedbackMsg">
          Thank you for your rating, kindly complete the short feedback survey & let us know how we can improve our services.
        </div>
      }
      @if (!feedbackDetails?.LinkExpired && !feedbackDetails?.IsFeedBackSubmitted && !IsFeedBackSubmittedOneTime && ClaimCustDetails.AgentRating==3) {
        <div class="feedbackMsg">
          We are sorry to hear that our services did not meet your expectations. We would appreciate if you let us know how we can improve our services through your feedback.
        </div>
      }
      @if (feedbackDetails?.LinkExpired) {
        <div class="feedbackMsg">
          Sorry, The Feedback link has expired !!
        </div>
      }
      @if (feedbackDetails?.IsFeedBackSubmitted) {
        <div class="feedbackMsg">
          Thank you for revisiting, we have already received your feedback for PB{{feedbackDetails?.ClaimId}}
        </div>
      }
      @if (IsFeedBackSubmittedOneTime) {
        <div class="feedbackMsg">
          Thank you for your feedback for PB{{feedbackDetails?.ClaimId}}
        </div>
      }
      @if (!feedbackDetails?.LinkExpired && !feedbackDetails?.IsFeedBackSubmitted && !IsFeedBackSubmittedOneTime) {
        <div class="feedbackBox">
          <form [formGroup]="feedbackForm">
            <div>
              @if (OnLoadVariables?.requestType==5) {
                <div class="questionBlock">
                  <p>How satisfied are you with the services provided by the Insurer, {{feedbackDetails?.InsurerName}}?</p>
                  <div class="options">
                    <label class="awesome">
                      <input type="radio" name="insurerRating" formControlName="insurerRating" value="1">
                      <span>Good</span>
                    </label>
                    <label class="sad">
                      <input type="radio" name="insurerRating" formControlName="insurerRating" value="3">
                      <span>Bad</span>
                    </label>
                  </div>
                </div>
              }
              <div class="questionBlock">
                @if (ClaimCustDetails.AgentRating==1) {
                  <p>Would you like to send a note of appreciation to {{feedbackDetails?.AgentName}}?</p>
                }
                @if (OnLoadVariables?.agentRating>1) {
                  <p>What could have been done better? Help us with your valuable suggestions to help us serve you better in the future.</p>
                }
                @if (ClaimCustDetails.AgentRating>0) {
                  <textarea placeholder="Enter Comment" formControlName="feedbackNote" required></textarea>
                }
              </div>
            </div>
            <div class="submitFeedback">
              <button type="submit" (click)="sendCustomerFeedback(true);" [disabled]="feedbackForm.invalid">Submit</button>
            </div>
          </form>
        </div>
      }
    </div>
  </div>
}

@if (ProductId==2 && !feedbackDetails?.IsFeedbackPageHide) {
  <div>
    @if (!feedbackDetails?.IsFeedbackPageHide) {
      <div class="container feedbackWrapper">
        @if (!feedbackDetails?.LinkExpired && !feedbackDetails?.IsFeedBackSubmitted && !IsFeedBackSubmittedOneTime && ClaimCustDetails.AgentRating==1) {
          <div class="feedbackMsg">
            We appreciate you rating our agent Awesome. Please let us know what you liked about services.
          </div>
        }
        @if (!feedbackDetails?.LinkExpired && !feedbackDetails?.IsFeedBackSubmitted && !IsFeedBackSubmittedOneTime && ClaimCustDetails.AgentRating==2) {
          <div class="feedbackMsg">
            Thank you for rating our agent. Please let us know how we could improve our services.
          </div>
        }
        @if (!feedbackDetails?.LinkExpired && !feedbackDetails?.IsFeedBackSubmitted && !IsFeedBackSubmittedOneTime && ClaimCustDetails.AgentRating==3) {
          <div class="feedbackMsg">
            Apologies for not meeting your expectations. Please give us your valuable suggestions so that we can improve.
          </div>
        }
        @if (feedbackDetails?.LinkExpired) {
          <div class="feedbackMsg">
            Sorry, The Feedback link has expired !!
          </div>
        }
        @if (feedbackDetails?.IsFeedBackSubmitted) {
          <div class="feedbackMsg">
            Thank you for revisiting, we have already received your feedback for PB Ref. PB{{feedbackDetails?.ClaimId}}
          </div>
        }
        @if (IsFeedBackSubmittedOneTime) {
          <div class="feedbackMsg">
            Thank you for your feedback for PB Ref. PB{{feedbackDetails?.ClaimId}}
          </div>
        }
        @if (!feedbackDetails?.LinkExpired && !feedbackDetails?.IsFeedBackSubmitted && !IsFeedBackSubmittedOneTime) {
          <div class="feedbackBox">
            <form [formGroup]="feedbackForm">
              <div>
                @if (OnLoadVariables?.requestType==2 && OnLoadVariables?.agentRating<3) {
                  <div class="questionBlock">
                    <p>How was your experience with your insurer, {{feedbackDetails?.InsurerName}}?</p>
                    <div class="options" >
                      <label class="awesome">
                        <input type="radio" name="insurerRating" formControlName="insurerRating" value="1" (click)="setQues()">
                        <span>Good</span>
                      </label>
                      <label class="sad">
                        <input type="radio" name="insurerRating" formControlName="InsurerRating" value="3" (click)="setQues()">
                        <span>Bad</span>
                      </label>
                    </div>
                    <br />
                    <br/>
                    @if (feedbackDetails?.IsPlatinum) {
                      <div>
                        <p>How satisfactory has treatment experience been for you with our platinum benefits?</p>
                        <div class="options">
                          <label class="awesome">
                            <input type="radio" formControlName="insurerRatingForPlatinum" value="1" (click)="setQues()">
                            <span>Good</span>
                          </label>
                          <label class="sad">
                            <input type="radio" name="InsurerRatingForPlatinum" ng-model="ClaimCustDetails.InsurerRatingForPlatinum" value="3" (click)="setQues()">
                            <span>Not Satisfied</span>
                          </label>
                        </div>
                      </div>
                    }
                  </div>
                }
                <div class="questionBlock">
                  @if (ClaimCustDetails.AgentRating<=2 && OnLoadVariables.requestType==2) {
                    <p>{{Ques}}</p>
                  }
                  @if (OnLoadVariables.agentRating==3 && !feedbackDetails?.IsPlatinum && OnLoadVariables.requestType==2) {
                    <p>Apologies! Please tell us in brief how we could improve our services?</p>
                  }
                  @if (OnLoadVariables.agentRating==3 && feedbackDetails?.IsPlatinum && OnLoadVariables.requestType==2) {
                    <p>Apologies! Tell us your experience with platinum benefits and please let us know in brief how we could improve our services?</p>
                  }
                  @if (OnLoadVariables.agentRating==1 && OnLoadVariables.requestType==1) {
                    <p>Would you like to send a note of appreciation to our agent, {{feedbackDetails?.AgentName}}?</p>
                  }
                  @if (OnLoadVariables.agentRating==2 && OnLoadVariables.requestType==1) {
                    <p>Please let us know how we could serve you better and how you would assess our claim representative?</p>
                  }
                  @if (OnLoadVariables.agentRating==3 && OnLoadVariables.requestType==1) {
                    <p>Apologies! Tell us how you would assess our claim representative. Please let us know how we could improve our services?</p>
                  }
                  @if (ClaimCustDetails.AgentRating>0) {
                    <textarea placeholder="Enter Comment" formControlName="feedbackNote"></textarea>
                  }
                </div>
              </div>
              <div class="submitFeedback">
                <button type="submit" (click)="sendCustomerFeedback(true);" [disabled]="feedbackForm.invalid">Submit</button>
              </div>
            </form>
          </div>
        }
      </div>
    }
  </div>
}
